import { isEqual } from "lodash";
import { datapointIdToString, getDimensionsForMeasures } from "../datapoints";
import { useGetDatapointsAllowedDimensions } from "./use-get-datapoints-allowed-dimensions";
import { DatapointIdStandardEnum, useGetDatapointsMetadata } from "api/ux/src";
import { useWorkshopEditor } from "store/widget-workshop/selectors";
export const excludedDatapointsIdList = [
    DatapointIdStandardEnum.AssetAssetId,
    DatapointIdStandardEnum.AssetBvdId,
    DatapointIdStandardEnum.AssetInvestorId,
    DatapointIdStandardEnum.FundFundId,
    DatapointIdStandardEnum.FundManagerId,
    DatapointIdStandardEnum.FundInvestorId,
    DatapointIdStandardEnum.FundBenchmarkId,
    DatapointIdStandardEnum.FundDefaultBenchmarkId,
    DatapointIdStandardEnum.PortfolioPortfolioId,
    DatapointIdStandardEnum.ManagerManagerId,
    DatapointIdStandardEnum.InstrumentAssetId,
    DatapointIdStandardEnum.InstrumentInstrumentId,
    DatapointIdStandardEnum.InstrumentInvestorId,
    DatapointIdStandardEnum.InstrumentDealId,
    DatapointIdStandardEnum.MarketMarketId,
    DatapointIdStandardEnum.FundFundMasterId,
    DatapointIdStandardEnum.AssetAssetMasterId,
    DatapointIdStandardEnum.DatapointMetadata,
    "Fund.ReportedCommitment",
    DatapointIdStandardEnum.InstrumentUnrealizedFairMarketValue
];
export const filterMetadataByAllowedDimensionsAndDatasetSelected = (metadata, datapointsAllowedDimensions, measures) => {
    if (excludedDatapointsIdList.some((d) => d === metadata.id)) {
        return false;
    }
    if (!measures.length) {
        return true;
    }
    const oneDatapointAllowedDimensions = datapointsAllowedDimensions.find((d) => {
        if (!d?.datapoint) {
            return false;
        }
        return datapointIdToString(d?.datapoint) === metadata?.id;
    });
    const dimensionForMeasures = getDimensionsForMeasures(measures.map((a) => a?.datapoint?.standard || ""), "", datapointsAllowedDimensions);
    if (oneDatapointAllowedDimensions) {
        return dimensionForMeasures?.some((a) => oneDatapointAllowedDimensions
            .allowedDimensions?.some((dim) => isEqual(a, datapointIdToString(dim))));
    }
    return false;
};
export const useGetDatapointsMetadataAndAllowedDimensions = () => {
    const measures = useWorkshopEditor().settings?.data?.columns?.options?.map((o) => o.datapoint) || [];
    const [datapointsAllowedDimensions] = useGetDatapointsAllowedDimensions();
    const [datapointsMetadata] = useGetDatapointsMetadata();
    if (datapointsAllowedDimensions.length !== 0) {
        return {
            datapointsAllowedDimensions,
            datapointsMetadata: datapointsMetadata
                .filter((metadata) => filterMetadataByAllowedDimensionsAndDatasetSelected(metadata, datapointsAllowedDimensions, (measures.filter((m) => m).map((m) => datapointsAllowedDimensions.find((d) => d.datapoint?.standard === m || d.datapoint?.custom === m)))))
        };
    }
    return { datapointsAllowedDimensions: [], datapointsMetadata: [] };
};
